import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { NMyOutfits } from './my-outfits.interfaces';

/**
 * Resolver to load CMS block configuration for the my outfits page
 */
export const accountMyOutfitsResolver: ResolveFn<void> = async () => {
    const iCmsBlockResource = inject(ICmsBlockResource);

    await iCmsBlockResource.retrieve({ bareUrl: NMyOutfits.componentId }, undefined);
};
